import React from 'react';

export default function NotFoundPage() {
  return <h1>Page not found</h1>;
}
